<template>
  <el-dropdown class="nymb-date-time-picker" trigger="click" @command="handleCommand">
      <span class="el-dropdown-link flex items-center justify-between">
          <p>{{ displayedLabel ? displayedLabel : convertedTo12Time(displayedValue) }}</p>
          <i class="el-icon-time text-base nymb-time-icon"></i>
      </span>
    <el-dropdown-menu slot="dropdown" class="nymb-time-picker-opt-sec" >
      <!-- v-if=" disabledCondition ? item.value > disabledCondition : ''" -->
      <template v-if="shiftTimeSlots.length">
        <el-dropdown-item class="nymb-time-picker-opt" v-for="item in shiftTimeSlots" :key="item.value" v-if="addNextDay ? true : (disabledCondition ? (item.value > disabledCondition) : true)" :command="item.value">
          <span v-if="disabledCondition">
            {{ item.label }} &nbsp; &nbsp; 
              {{ `(${getShiftDuration(disabledCondition, item.value)} Hrs)` }} 
          </span>
          <span v-else>
            {{ item.label }}
          </span>
        </el-dropdown-item>
      </template>
      <template v-else>
        <el-dropdown-item>
          No Data Found
        </el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    displayedValue: {
      type: String,
      default: '',
    },
    disabledCondition: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    shiftTimeSlots: {
      type: Array || String,
    },
    placeholder: {
      type: String,
      default: 'Select Time'
    },
    displayedLabel: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'YYYY-MM-DDTHH:mm:ss'
    },
    addNextDay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  methods: {
    handleCommand(value) {
      // Emit an input event with the selected value
      this.$emit('input', value);
      this.$emit('change', event)
    },
    convertedTo12Time(time){
      return time ? moment(time, this.format).format("hh:mm A") : this.placeholder
    },
    getShiftDuration(start, opt){
      // console.log(start, opt, 'ddd')
      if(this.addNextDay){
        let startAt = moment(start, this.format);
        let endAt = moment(opt, this.format).add(1, 'days');
        let duration = endAt.diff(startAt, 'minutes');
        return duration ? duration/60 : 0;
      }
      let startAt = moment(start, this.format);
      let endAt = moment(opt, this.format);
      let duration = endAt.diff(startAt, 'minutes');
      return duration ? duration/60 : 0;
    }
  },
};
</script>

<style>
.el-dropdown-link {
  padding: 0;
  border: none;
  background-color: transparent;
  color: #000;
}
.nymb-date-time-picker.el-dropdown {
  padding: 12px 30px;
  width: 100%;
  border: #dae1e7 1px solid;
  border-radius: 5px;
  color: #505050;
}
.nymb-date-time-picker.el-dropdown p {
  color: #505050;
}
.nymb-time-icon {
  color: #505050;
}
.nymb-time-picker-opt-sec{
  max-height: 250px;
  width: fit-content;
  overflow-y: scroll;
}
.nymb-time-picker-opt {
  padding: 0 35px;
}
::-webkit-scrollbar-track {
background: #ffff;
}

::-webkit-scrollbar-thumb {
background: #c1c1c1;
border-radius: 15px;
cursor: pointer;
}
::-webkit-scrollbar {
height: 8px;
overflow: visible;
width: 8px;
}
</style>